import { Info } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

interface PvCurtailmentTooltipProps {
  className?: string;
}

/**
 * Small info tooltip explaining PV curtailment behavior.
 * Prevents user confusion when solar production appears low.
 */
export function PvCurtailmentTooltip({ className = '' }: PvCurtailmentTooltipProps) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className={`inline-flex items-center cursor-help ${className}`}>
            <Info className="h-3.5 w-3.5 text-muted-foreground hover:text-foreground transition-colors" />
          </span>
        </TooltipTrigger>
        <TooltipContent className="max-w-[280px] p-3" side="top">
          <p className="text-xs text-muted-foreground leading-relaxed">
            Solar production may be limited when batteries are full and energy usage is low.
            This is normal system behavior and does not indicate reduced solar capability.
          </p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
